import { Role } from 'constants/roles';

import { useGoBack } from 'hooks/useGoBack';
import { usePermissions } from 'hooks/usePermissions';
import { useFormContext } from 'react-hook-form';
import { CancelButton, SaveButton } from 'shared/mui/Buttons';
import { CardActionsButtons } from 'shared/mui/Card';

import { CommissionsCreateFormValues } from './CommissionsCreateForm';

type Props = {
  onCreate: () => void;
  onSaveAndApprove: () => void;
};

export const CommissionsCreateToolbar: React.FC<Props> = ({ onCreate, onSaveAndApprove }) => {
  const { goBack } = useGoBack();
  const { roles } = usePermissions();
  const { watch } = useFormContext<CommissionsCreateFormValues>();
  const isLadderWatched = watch('isLadder');

  return (
    <CardActionsButtons
      rightActionsSlot={[
        <CancelButton key="cancel-button" onClick={goBack} variant="outlined" />,
        !isLadderWatched && <SaveButton key="create-button" label="Создать" onClick={onCreate} />,
        (roles?.includes(Role.Admin) || isLadderWatched) && (
          <SaveButton key="save-button" label="Создать и согласовать" onClick={onSaveAndApprove} />
        ),
      ]}
      sx={{ marginTop: 'auto', padding: 0 }}
    />
  );
};
